export default function (category) {
  return {
    name: 'catalog',
    params: {
      categoryId: category.short_id,
      categorySlug: category.slug,
    },
  }
}
